class PredictiveArticleSearch extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      input: "[data-article-search-input]",
      resultContainer: ".article-search-result-container",
    };
    this.input = this.querySelector(this.selectors.input);
    this.resultContainer = this.querySelector(this.selectors.resultContainer);
    this.setupEventListeners();
  }

  setupEventListeners() {
    document.body.addEventListener(
      "click",
      function (e) {
        if (!e.target.closest("predictive-article-search")) {
          this.input.value = "";
          this.close();
        }
      }.bind(this)
    );
    this.input.addEventListener(
      "input",
      debounce((e) => {
        this.close();
        this.onChange(e);
      }, 800).bind(this)
    );
  }
  onChange() {
    this.query = this.input.value.trim();
    this.query.length ? this.getSearchResults() : this.close(!0);
  }
  onClearSearch(e) {
    e.preventDefault(), (this.input.value = ""), this.onChange();
  }
  getSearchResults() {
    let queryUrl = `${
      window.MinimogSettings.routes.predictive_search_url
    }?q=${encodeURIComponent(
      this.query
    )}&resources[type]=article&section_id=predictive-article-search`;
    fetch(`${queryUrl}`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        const resultContent = new DOMParser()
          .parseFromString(response, "text/html")
          .querySelector(
            "#shopify-section-predictive-article-search"
          ).innerHTML;
        this.resultContainer.innerHTML = resultContent;
      })
      .catch((response) => {
        throw (this.close(), response);
      });
  }
  close(e) {
    this.resultContainer.innerHTML = "";
  }
}
customElements.define("predictive-article-search", PredictiveArticleSearch);

class LoadMoreArticles extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector("a");
    this.articlesContainer = this.closest(".shopify-section").querySelector(
      "[data-articles-container]"
    );
    this.paginateContainer = this.closest(".shopify-section").querySelector(
      "[data-pagination-container]"
    );
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.link) {
      this.link.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          this.fetchArticles();
        }.bind(this)
      );
    }
  }
  fetchArticles(e) {
    this.classList.add("active");
    fetch(`${this.dataset.next}`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        console.log("cis", response);
        const Html = new DOMParser().parseFromString(response, "text/html");
        const articles = Html.querySelector("[data-articles-container]");
        const paginates = Html.querySelector("[data-pagination-container]");
        // this.resultContainer.innerHTML = resultContent;
        if (this.articlesContainer && articles) {
          this.articlesContainer.innerHTML += articles.innerHTML;
        }
        if (this.paginateContainer) {
          if (paginates) {
            this.paginateContainer.innerHTML = paginates.innerHTML;
          } else {
            this.paginateContainer.remove();
          }
        }
      })
      .catch((response) => {
        throw (this.close(), response);
      });
  }
}
customElements.define("load-more-articles", LoadMoreArticles);

class CollapsibleTabHeader extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest(".m-collapsible-section__wrapper");
    this.tabQuery = this.dataset.content;
    if (this.tabQuery == window.location.hash) {
      this.showActive();
    }
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener(
      "click",
      function (e) {
        if (this.classList.contains("active")) {
          this.removeActive();
          window.location.hash = "";
        } else {
          this.removeActive();
          this.showActive();
          window.location.hash = this.tabQuery;
        }
      }.bind(this)
    );
  }
  showActive() {
    if (this.parent.querySelector(this.tabQuery)) {
      this.classList.add("active");
      this.parent.querySelector(this.tabQuery).classList.add("active");
      window.location.hash = this.tabQuery;
    }
  }
  removeActive() {
    if (this.parent.querySelector(".collapsible-tab-header.active")) {
      this.parent
        .querySelector(".collapsible-tab-header.active")
        .classList.remove("active");
    }
    if (this.parent.querySelector(".m-collapsible-tab-content.active")) {
      this.parent
        .querySelector(".m-collapsible-tab-content.active")
        .classList.remove("active");
    }
  }
}
customElements.define("collapsible-tab-header", CollapsibleTabHeader);

document.addEventListener("shopify:block:select", function (e) {
  if (e.target.classList.contains("collapsible-tab-header")) {
    e.target.removeActive();
    e.target.showActive();
  }
});

function featuredSlider(sliderContainer) {
  new MinimogLibs.Swiper(sliderContainer, {
    slidesPerView: 1.2,
    loop: false,
    spaceBetween: 12,
    centeredSlides: false,
    navigation: {
      nextEl: sliderContainer.querySelector(".m-slider-controls__button-next"),
      prevEl: sliderContainer.querySelector(".m-slider-controls__button-prev"),
    },
  });
}
document.addEventListener("DOMContentLoaded", () => {
  if (!localStorage.getItem("hasVisited")) {
    if (document.querySelector(".welcome-popup")) {
      document.querySelector(".welcome-popup").classList.add("active");
    }
  }
  const welcomePopupClose = document.querySelector(".welcome-popup-close");
  if (welcomePopupClose) {
    welcomePopupClose.addEventListener("click", () => {
      if (welcomePopupClose.closest(".welcome-popup")) {
        welcomePopupClose.closest(".welcome-popup").classList.remove("active");
      }
    });
  }
  const welcomePopupFullwidthClose = document.querySelector(
    ".welcome-popup-close.full-width"
  );
  if (welcomePopupFullwidthClose) {
    welcomePopupFullwidthClose.addEventListener("click", () => {
      if (welcomePopupFullwidthClose.closest(".welcome-popup")) {
        welcomePopupFullwidthClose
          .closest(".welcome-popup")
          .classList.remove("active");
      }
    });
  }
  const sizeGuideWarningClose = document.querySelector(
    ".size-guide-warning-close"
  );
  if (sizeGuideWarningClose) {
    sizeGuideWarningClose.addEventListener("click", () => {
      if (sizeGuideWarningClose.closest(".size-guide-warning-popup")) {
        sizeGuideWarningClose
          .closest(".size-guide-warning-popup")
          .classList.remove("active");
        localStorage.setItem("hasPdpVisited", true);
      }
    });
  }

  const sizeGuideWarningFullwidthClose = document.querySelector(
    ".size-guide-warning-close.full-width"
  );
  if (sizeGuideWarningFullwidthClose) {
    sizeGuideWarningFullwidthClose.addEventListener("click", () => {
      if (sizeGuideWarningFullwidthClose.closest(".size-guide-warning-popup")) {
        sizeGuideWarningFullwidthClose
          .closest(".size-guide-warning-popup")
          .classList.remove("active");
        localStorage.setItem("hasPdpVisited", true);
      }
    });
  }

  const productFeatureSlider = document.querySelector(
    ".product-features-slider"
  );
  if (productFeatureSlider) {
    window.featuredSlider;
    featuredSlider(productFeatureSlider);
  }
});